import { base64UrlToString } from "@pgs-core/auth/base64url";

export type JwtClaims = Record<string, unknown>;

export function readJwtClaims(token: string): JwtClaims {
  if (typeof token !== "string" || token.length === 0) {
    throw new Error("JWT access token is missing");
  }

  const segments = token.split(".");

  if (segments.length !== 3 || segments[1].length === 0) {
    throw new Error("JWT access token is malformed");
  }

  const claims = JSON.parse(base64UrlToString(segments[1]));

  if (!claims || typeof claims !== "object" || Array.isArray(claims)) {
    throw new Error("JWT payload is not an object");
  }

  return claims as JwtClaims;
}

export function hasRoleClaim(claims: JwtClaims, role: string): boolean {
  return claims.role === role;
}

export function readTenantIdClaim(claims: JwtClaims): string {
  return typeof claims.tenant_id === "string" && claims.tenant_id.trim().length > 0
    ? claims.tenant_id
    : "";
}

/** Absolute expiry (epoch ms) of a JWT, or null when it has no readable exp. */
export function tokenExpiryMs(token: string): number | null {
  try {
    const exp = readJwtClaims(token).exp;
    return typeof exp === "number" ? exp * 1000 : null;
  } catch {
    return null;
  }
}

export function describeRoleClaim(claims: JwtClaims): string {
  return typeof claims.role === "string" && claims.role.length > 0 ? claims.role : "missing";
}
